import { Typography } from '@mui/material';

import ConditionManualRule, {
  ConditionManualRules,
} from './conditionManualRule';

interface IncludeExcludeConditionProps {
  onIncludeDelete: (resourceId: string) => void;
  onExcludeDelete: (resourceId: string) => void;
  include: string[];
  exclude: string[];
}

export const IncludeExcludeCondition = (
  props: IncludeExcludeConditionProps
) => {
  const { include, onIncludeDelete, exclude, onExcludeDelete } = props;
  return (
    <>
      <Typography variant='body1' sx={{ mt: '24px', mb: '24px' }}>
        Include or exclude these resources:
      </Typography>
      {!!include?.length && (
        <>
          <Typography variant='body2' sx={{ mb: '12px' }}>
            Include:
          </Typography>
          <ConditionManualRules>
            {include.map((resource) => {
              return (
                <ConditionManualRule
                  resourceId={resource}
                  key={resource}
                  onDelete={onIncludeDelete}
                />
              );
            })}
          </ConditionManualRules>
        </>
      )}
      {!!exclude?.length && (
        <>
          <Typography variant='body2' sx={{ mt: '24px', mb: '12px' }}>
            Exclude:
          </Typography>
          <ConditionManualRules>
            {exclude.map((resource) => {
              return (
                <ConditionManualRule
                  resourceId={resource}
                  key={resource}
                  onDelete={onExcludeDelete}
                />
              );
            })}
          </ConditionManualRules>
        </>
      )}
    </>
  );
};
